import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import Clickable from 'components/Common/Clickable'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'

const Container = styled(Clickable)`
  position: relative;
  display: flex;
  height: fit-content;
  align-items: center;
  width: 100%;
  background-color: ${(props) => props.theme.palette.neutral.surface.normalBackground};
  border: 1px solid ${(props) => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${(props) => props.theme.borderRadius.S};
`

const Item = styled.div`
  padding: ${rem(8)} ${rem(16)};
  width: 100%;
  justify-self: stretch;

  &:not(:first-child) {
    border-inline-start: 1px solid ${(props) => props.theme.palette.neutral.surface.lightForeground};
  }
`

interface BaseProps extends PropsWithChildren<{}> {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

interface Props extends BaseProps {
  title?: string
  subTitle?: string
}

export function PlaceInputTrigger({
  onClick,
  title,
  subTitle,
}: Props) {
  const intl = useIntl()

  const resolvedTitle = title ?? intl.formatMessage({
    id: '1ssHG_hYxtwCbkhcsTiJ',
    defaultMessage: 'Where',
    description: 'Default label for destination input trigger in trip planner search',
  })

  const resolvedSubTitle = subTitle ?? intl.formatMessage({
    id: 'NIc-nTwf285q6B-zRzuJ',
    defaultMessage: 'Search for a destination or hotel',
    description: 'Default placeholder text for destination input trigger in trip planner search',
  })

  return (
    <Container onClick={onClick}>
      <Item>
        <Caption variant="large" weight="bold">
          {resolvedTitle}
        </Caption>
        <BodyText colour="light-foreground-alt" variant="medium">
          {resolvedSubTitle}
        </BodyText>
      </Item>
    </Container>
  )
}
